<section class="px-4 md:px-15 lg:px-15 pt-5 bg-primary-200">
    <div class="container mx-auto flex px-5 md:flex-row flex-col items-center">
        <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 md:mr-10 items-center">
            <img class="object-cover object-center rounded" alt="hero" src="assets/images/sections/why-us-01.png" />
        </div>
        <div class="lg:flex-grow md:w-1/2 flex flex-col md:items-start md:text-left items-center text-center pb-10">
            <div class="flex items-baseline">
                <h6 class="uppercase font-semibold tracking-widest text-lg text-secondary-500 md:mr-3 mt-10">Why choose
                    us</h6>
                <span class="w-10 border-b-2 border-primary-500"></span>
                <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
            </div>
            <h1 class="text-xl font-semibold font-primary tracking-wide md:text-3xl lg:text-6xl">
                Explore the world...
            </h1>
            <p class="mt-3">
                Simply Nexus is a proud member of the XL Travel Group and as such has access to the groups negotiated deals, technology platforms and carefully curated preferred suppliers. With a team of well-travelled, senior “Travel Simplifiers”, we aim to provide the best service, pricing and advise to ensure that your travel arrangements are seamless, taking the stress out of the planning and booking of your next dream escape.
            </p>
             <!-- <p class="mt-3">
                Simply Nexus is the leisure arm of XL Nexus Travel. Originally founded in 2003 as Harveyworld Woodmead,
                the company went through rapid growth and now enjoys a staff compliment of over 200 staff. The leisure
                division boasts a team of well-travelled senior consultants and an in-house visa officer to assist with
                passport and visa services.
            </p> -->
            <div class="mt-10">
                <dl class="space-y-2 md:space-y-4 grid grid-cols-1 gap-x-8 gap-y-3">
                    <div class="relative">
                        <dt>
                            <div
                                class="hidden absolute sm:flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                                <img src="assets/icons/icon-guarantee-certificate.png">
                            </div>
                            <p class="font-heading sm:ml-16 text-lg leading-6 font-bold">Expertise</p>
                        </dt>
                        <dd class="mt-2 sm:ml-16 text-base">
                            With over 100 years of combined travel experience, the team can assist with any travel
                            related service, with customer satisfaction and
                            service excellence at the core of the teams value proposition.
                        </dd>
                    </div>
                    <div class="relative">
                        <dt>
                            <div
                                class="hidden absolute sm:flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                                <img src="assets/icons/booking.png">
                            </div>
                            <p class="font-heading sm:ml-16 text-lg leading-6 font-bold">Technology</p>
                        </dt>
                        <dd class="mt-2 sm:ml-16 text-base">As part of the XL Travel group, the team has
                            access to a wealth of travel technology products, including land and air aggregation booking
                            engines offering NDC faring,
                            competitive accommodation rates and the traveller’s best friend, XLGO, an app with features
                            such as:
                            <ul class="list-disc list-inside pl-5 text-center md:text-left mt-5">
                                <li>Offline travel guides with over 1800 destinations worldwide</li>
                                <li>Attractions, restaurants, nightlife, worldwide shopping, etc.</li>
                                <li>Integrate your preferred expense management solution</li>
                                <li>Trip Genius™ for suggested itineraries according to preferences</li>
                                <li>Trip Journal and social media sharing</li>
                                <li>Augmented reality </li>
                            </ul>
                        </dd>
                    </div>
                    <div class="relative">
                        <dt>
                            <div
                                class="hidden absolute sm:flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                                <img src="assets/icons/help-desk.png">

                            </div>
                            <p class="font-heading sm:ml-16 text-lg leading-6 font-bold">Value</p>
                        </dt>
                        <dd class="mt-2 sm:ml-16 text-base">Simply Nexus offers a full turnkey service for
                            its clients, from assisting with online check-ins to loading documents into the traveller’s
                            app (XLGO), we have the right people,
                            knowledge, and technology to offer an end-to-end experience, taking the stress out of
                            planning and booking travel. We aim to simplify the journey, from start to finish.
                        </dd>
                    </div>
                </dl>
            </div>

        </div>
    </div>
</section>